import { Box, Typography } from '@mui/material';
import instagramLogo from '../../assets/images/instagram-logo.svg';
import linkedinLogo from '../../assets/images/linkedin-logo.svg';
import logo from '../../assets/images/logo-white.png';
import { colors, fonts } from '../../theme';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        // Above the sponsors wrapper's blue background (which it overlaps), below the seabed image.
        position: 'relative',
        zIndex: 1,
        backgroundColor: colors.footerSurface,
        borderTop: `1px solid ${colors.footerBorder}`,
        px: { xs: 3, md: 6 },
        pb: { xs: 4, md: 5 },
        // Extra top room: the seabed image above overlaps the footer by 6vw.
        pt: { xs: 'calc(6vw + 32px)', md: 'calc(6vw + 40px)' },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 3,
        }}
      >
        <Box
          component="img"
          src={logo}
          alt="CSES Computer Science & Engineering Society"
          sx={{ height: { xs: '56px', md: '72px' }, width: 'auto' }}
        />

        <Box sx={{ display: 'flex', gap: 2 }}>
          <Box
            component="a"
            href="https://www.instagram.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 56,
              height: 56,
              borderRadius: '12px',
            }}
          >
            <Box component="img" src={instagramLogo} alt="Instagram" sx={{ width: '100%', height: '100%', display: 'block' }} />
          </Box>
          <Box
            component="a"
            href="https://www.linkedin.com"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 56,
              height: 56,
              borderRadius: '12px',
            }}
          >
            <Box component="img" src={linkedinLogo} alt="LinkedIn" sx={{ width: '100%', height: '100%', display: 'block' }} />
          </Box>
        </Box>
      </Box>

      <Typography
        sx={{
          fontFamily: fonts.fine,
          fontSize: '0.85rem',
          lineHeight: 1.6,
          color: colors.mutedGray,
          textAlign: 'center',
          mt: { xs: 4, md: 5 },
        }}
      >
        © 2026 UC San Diego Computer Science and Engineering Society. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
